import(/* webpackMode: "eager" */ "/srv/apps/internationaljobs/releases/d4e8da4-202611041332/src/app/error.tsx");
